import React from "react";
import { useWishlist } from "./Wishlistcontext";
import { useCart } from "./cartContext";
import { Link } from "react-router-dom";
import { X, ShoppingCart } from "lucide-react";

export default function Wishlist() {
  const { wishlistItems, removeFromWishlist } = useWishlist();
  const { addToCart, cartItems } = useCart();

  if (!wishlistItems.length) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-gray-50">
        <div className="text-center p-6 rounded-xl">
          <div className="w-24 h-24 bg-gray-200 rounded-full flex items-center justify-center mb-4 mx-auto">
            <ShoppingCart className="w-12 h-12 text-gray-400" />
          </div>
          <h2 className="text-2xl font-bold mb-2">Your wishlist is empty</h2>
          <p className="text-gray-600 mb-4">
            Add products to start your wishlist!
          </p>
          <Link
            to={"/"}
            className="bg-[#fe7590] text-white hover:bg-red-700 px-4 py-2 rounded-xl shadow"
          >
            Continue Shopping
          </Link>
        </div>
      </div>
    );
  }

  const isInCart = (product) =>
    cartItems.some(
      (item) =>
        `${item.category}-${item.id}-${item.name}` ===
        `${product.category}-${product.id}-${product.name}`
    );

  return (
    <div className="min-h-screen bg-gray-50 py-10">
      <div className="max-w-7xl mx-auto px-4">
        <h1 className="text-3xl font-bold mb-8 text-center">My Wishlist</h1>
        <div className="flex flex-wrap gap-8 justify-center">
          {wishlistItems.map((product) => {
            const inCart = isInCart(product);
            return (
              <article
                key={`${product.category}-${product.id}-${product.name}`}
                className="bg-white shadow-lg rounded-xl overflow-hidden w-72 relative hover:shadow-2xl transition-shadow duration-300 flex flex-col"
              >
                {/* Sale Badge */}
                {product.sale_price && product.sale_price > 0 && (
                  <span className="absolute top-3 left-3 bg-[#fe7590] text-white text-xs font-bold px-3 py-1 rounded-full z-10 uppercase shadow-md">
                    Sale
                  </span>
                )}

                {/* Product Image */}
                <Link
                  to={`/productinfo/${product.id}/${product.category}`}
                  className="relative overflow-hidden h-80 flex justify-center items-center"
                >
                  <img
                    src={product.image}
                    alt={product.name}
                    className="object-contain transition-transform duration-500 hover:scale-110"
                  />
                </Link>

                {/* Product Details */}
                <div className="p-4 flex flex-col gap-2 flex-1">
                  <Link to={`/productinfo/${product.id}/${product.category}`}>
                    <h3 className="font-semibold text-black">{product.name}</h3>
                    <p className="text-gray-500 text-sm line-clamp-2">
                      {product.description}
                    </p>
                    <div className="flex items-center gap-2 mt-2">
                      {product.sale_price && product.sale_price > 0 ? (
                        <>
                          <span className="text-[#fe7590] font-bold text-lg">
                            ${product.sale_price}
                          </span>
                          <span className="text-gray-400 line-through text-sm">
                            ${product.price}
                          </span>
                        </>
                      ) : (
                        <span className="text-gray-800 font-bold text-lg">
                          ${product.price}
                        </span>
                      )}
                    </div>
                  </Link>

                  {/* Action Buttons */}
                  <div className="mt-auto flex justify-between items-center gap-2">
                    <button
                      onClick={() => addToCart(product)}
                      className={`cursor-pointer flex-1 py-2 rounded-lg border border-black text-sm font-semibold ${
                        inCart
                          ? "bg-green-500 text-white cursor-not-allowed"
                          : "bg-white hover:bg-green-500 hover:text-white"
                      } transition-all duration-300`}
                      disabled={inCart}
                    >
                      {inCart ? "In Cart" : "Add to Cart"}
                    </button>

                    <button
                      onClick={() => removeFromWishlist(product)}
                      className="p-2 text-[#fe7590] hover:text-red-700 transition"
                    >
                      <abbr title="Remove From WishList">
                        <X
                          src="/assests/icons/remove.png"
                          alt="Remove"
                          className="w-5 h-5 cursor-pointer"
                        />
                      </abbr>
                    </button>
                  </div>
                </div>
              </article>
            );
          })}
        </div>
      </div>
    </div>
  );
}
